/* Mavula Seats — Find My Fit configurator */
(function () {
  'use strict';

  const FIT = {
    'Toyota Hilux': {
      note: '2016-2024, Manual Seat Models',
      Premium:   ['Charcoal Canvas - Dark Brown Leather', 'Black Canvas - Whiskey Leather'],
      Exclusive: ['Charcoal Canvas - Dark Brown Leather', 'Black Canvas - Whiskey Leather'],
      img: '{{ "product-front-seats.jpg" | asset_url }}',
    },
    'Toyota LandCruiser 79 Series': {
      note: 'Manual Seat Models',
      Premium:   ['Black Canvas - Whiskey Leather'],
      Exclusive: ['Black Canvas - Whiskey Leather'],
      img: '{{ "product-rear-bench.jpg" | asset_url }}',
    },
  };

  const PRICE = {
    Premium:   { front: '$999',   full: '$1,550' },
    Exclusive: { front: '$699',   full: '$1,099' }
  };

  const modelSel  = document.getElementById('fit-model');
  const rangeSel  = document.getElementById('fit-range');
  const showBtn   = document.getElementById('fit-show');
  const resultEl  = document.getElementById('fit-result');

  if (!modelSel || !rangeSel || !showBtn || !resultEl) return;

  // Get image URLs from data attributes (set by Liquid) — keyed by model+range
  const imgMap = {
    'Toyota Hilux':                  { Premium: modelSel.dataset.imgHiluxPremium   || '', Exclusive: modelSel.dataset.imgHiluxExclusive   || '' },
    'Toyota LandCruiser 79 Series':  { Premium: modelSel.dataset.imgLandcruiserPremium || '', Exclusive: modelSel.dataset.imgLandcruiserExclusive || '' },
  };

  function reset() { resultEl.hidden = true; }

  modelSel.addEventListener('change', reset);
  rangeSel.addEventListener('change', reset);

  showBtn.addEventListener('click', function () {
    const model = modelSel.value;
    const range = rangeSel.value;
    const data  = FIT[model];
    if (!data) return;

    const ways       = data[range];
    const img        = (imgMap[model] && imgMap[model][range]) || '';
    const productUrl = '/products/' + range.toLowerCase() + '-range';

    const isMobile = window.innerWidth <= 600;
    const linkStyle = isMobile ? 'flex-direction:column;align-items:flex-start;' : '';
    const imgStyle  = isMobile ? 'width:100%;height:200px;object-fit:cover;border-radius:var(--radius-sm);flex-shrink:0;' : '';

    const prices = PRICE[range] || {};
    resultEl.innerHTML = `
      <a href="${productUrl}" class="fit__result-link" style="${linkStyle}" aria-label="View ${range} Range product page">
        <img src="${img}" alt="Matched Mavula set" loading="lazy" style="${imgStyle}">
        <div class="fit__match">
          <h4>${model} · ${range} Range</h4>
          <p>${data.note} &middot; Limited launch stock</p>
          <div class="fit__ways">${ways.map(w => `<span class="fit__way">${w}</span>`).join('')}</div>
        </div>
        <div class="fit__price">
          <div class="fit__price-table">
            <div class="fit__price-row"><span>Front Package</span><span>${prices.front || ''}</span></div>
            <div class="fit__price-row fit__price-row--full"><span>Full Set</span><span>${prices.full || ''}</span></div>
          </div>
          <div class="u">View product <span style="display:inline-block;transform:translateX(0);transition:transform .25s">→</span></div>
        </div>
      </a>
    `;
    resultEl.hidden = false;
  });
})();
